import React from 'react';
import {Box,Button} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

const FilterHandler = ({filter,setFilter=()=>{}}) => {
  return ( <Box sx={{ display: 'flex', justifyContent: 'end' }}    >
                    <Button onClick={() => {
                        setFilter((prev) => !prev)
                    }} type='submit' sx={{
                        background: "rgba(30, 106, 253, 1)",
                        borderRadius: "8px",
                        color: "#fff",
                        padding: "0.4rem 1rem",
                        "&:hover": { background: "rgba(30, 106, 253, 0.8)" },
                    }} endIcon={filter ? <FilterAltOffIcon /> : <FilterAltIcon />}>
                        {
                            !filter ? 'فیلتر' : 'بستن'
                        }
                    </Button>
                </Box>
  )
}

export default FilterHandler